// @flow
import React from 'react';
import type { Children } from 'react';
import styled from 'styled-components';
import shortid from 'shortid';

import { colors } from '../../../shared/styles';

type SelectProps = {
    children?: Children,
    disabled: boolean,
    input: any,
    label: string,
    multiple?: boolean,
    size?: number,
    meta: any,
};

const StyledSelect = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & label {
        font-size: 13px;
        display: block;
        padding: 6px 0;
    }

    & select {
        width: 100%;
        height: 31px;
        box-sizing: border-box;
        background: ${colors.white};
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
        font-size: 14px;
    }

    & select[multiple] {
        height: 100%;
    }

    & select[disabled] {
        background: ${colors.offWhiteLighter};
    }

    &.input-error {
        & label {
            color: ${colors.error.default};
        }

        & select {
            border-color: ${colors.error.default};
        }

        span {
            display: block;
            color: ${colors.error.default};
            font-size: 13px;
            margin-top: 5px;
        }
    }
`;

const Select = (props: SelectProps) => {
    const {
        children,
        disabled,
        input,
        label,
        multiple,
        size,
        meta: { touched, error, submitFailed } = {},
    } = props;
    const id = shortid.generate();

    const showError = (touched || submitFailed) && error;
    const wrapperCls = showError ? 'input-error' : '';

    return (
        <StyledSelect className={wrapperCls}>
            {label &&
                <label htmlFor={id}>
                    {label}:
                </label>}
            <select
                {...input}
                id={id}
                disabled={disabled}
                multiple={multiple}
                size={size}
            >
                {children}
            </select>
            {showError &&
                <span>
                    {error}
                </span>}
        </StyledSelect>
    );
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/shared/forms/Select.js